import * as commonService from '@/services/common';
import { useUserStore } from '@/stores/modules/user';

interface TrackingProperties {
  actionKey?: string; // 事件名称 event,
  pageTitle?: string; // 页面名称 pg_name,
  taskHandler?: string; // 	用户操作 operation_name
  taskState?: number | string; // 操作状态 c_status
  eventIntervalSpan?: number; // 停留时长(ms) event_duration
  timeZone?: number; // 客户端时间
  growArea?: string; // 扩展字段 popup_name c_msg ？
  userKey?: string; // userId ?
}

const reportTrackData = async (reportData: Record<string, any>) => {
  if (!window.__g_router__.currentRoute.meta?.trackingPgName) return;

  const userStore = useUserStore();
  await commonService.reportTrackData({ ...userStore.commonData, ...reportData });
};

const TrackingData = {
  async trackPageEnter(properties: TrackingProperties) {
    await reportTrackData({
      actionKey: 'page_enter',
      pageTitle: window.__g_router__.currentRoute.meta?.trackingPgName,
      taskHandler: window.__g_router__.currentRoute.meta?.trackingPgName + '-pagein',
      ...properties,
      timeZone: new Date().getTime(),
    });
  },
  async trackPageEnd(properties: TrackingProperties) {
    await reportTrackData({
      actionKey: 'page_end',
      pageTitle: window.__g_router__.currentRoute.meta?.trackingPgName,
      taskHandler: window.__g_router__.currentRoute.meta?.trackingPgName + '-pageout',
      ...properties,
      timeZone: new Date().getTime(),
    });
  },
  async trackClick(properties: TrackingProperties) {
    await reportTrackData({
      actionKey: 'click',
      pageTitle: window.__g_router__.currentRoute.meta?.trackingPgName,
      ...properties,
      timeZone: new Date().getTime(),
    });
  },
  async trackInput(properties: TrackingProperties) {
    await reportTrackData({
      actionKey: 'input',
      pageTitle: window.__g_router__.currentRoute.meta?.trackingPgName,
      ...properties,
      timeZone: new Date().getTime(),
    });
  },
  async trackMove(properties: TrackingProperties) {
    await reportTrackData({
      actionKey: 'move',
      pageTitle: window.__g_router__.currentRoute.meta?.trackingPgName,
      ...properties,
      timeZone: new Date().getTime(),
    });
  },
  async trackIdentify(properties: TrackingProperties) {
    await reportTrackData({
      actionKey: 'identify',
      pageTitle: window.__g_router__.currentRoute.meta?.trackingPgName,
      ...properties,
      timeZone: new Date().getTime(),
    });
  },
  async trackPopup(properties: TrackingProperties) {
    await reportTrackData({
      actionKey: 'popup',
      pageTitle: window.__g_router__.currentRoute.meta?.trackingPgName,
      ...properties,
      timeZone: new Date().getTime(),
    });
  },
};

export default TrackingData;
